import { z } from 'zod';
import type { ApiSchemaClass, ApiSchemaDefinition } from './types';

export const orgProvisionBodyV20260601Schema = z.object({
  name: z
    .string()
    .min(1)
    .describe(
      'Human-readable name for the provisioned org (e.g. "acme/ledger-api"). Also used to name its WorkOS organization and API key.'
    ),
});

export type OrgProvisionBody = z.infer<typeof orgProvisionBodyV20260601Schema>;

export const orgProvisionResponseV20260601Schema = z.object({
  orgId: z
    .string()
    .describe('Cotera org id of the newly provisioned organization.'),
  apiKey: z
    .object({
      id: z.string().describe('WorkOS identifier of the created API key.'),
      value: z
        .string()
        .describe(
          'Plaintext API key value. Returned only once, at creation — store it now; it cannot be retrieved again.'
        ),
    })
    .describe(
      'Org-owned API key used to authenticate subsequent requests as the provisioned org.'
    ),
});

export type OrgProvisionResponse = z.infer<
  typeof orgProvisionResponseV20260601Schema
>;

export class OrgProvisionV20260601Schema implements ApiSchemaDefinition {
  static readonly version = 'org-provision-2026-06-01' as const;

  readonly name = OrgProvisionV20260601Schema.version;
  readonly schema = orgProvisionBodyV20260601Schema;
  readonly response = orgProvisionResponseV20260601Schema;
}

export const ORG_API_SCHEMAS = [
  OrgProvisionV20260601Schema,
] as const satisfies readonly ApiSchemaClass[];
